<template>
  <div>
    <v-container class="map-container">
      <l-map
        ref="geometry-map"
        :padding="padding"
        :options="{ preferCanvas: true, minZoom: 3 }"
        @ready="onMapReady"
      >
        <l-tile-layer v-bind="tilesOpts" />
        <l-control position="topleft" class="leaflet-bar leaflet-control">
          <a>
            <v-icon class="leaflet-center">mdi-fit-to-page-outline</v-icon>
          </a>
        </l-control>
      </l-map>
    </v-container>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { LControl, LMap, LTileLayer } from 'vue2-leaflet';
import L, { PointExpression } from 'leaflet';
import { MAP_ATTRIBUTION, TILES_URL } from '@/constants/map/mapConstants';

@Component({
  components: {
    LMap,
    LTileLayer,
    LControl
  }
})
export default class DomainsGeometryMap extends Vue {
  @Prop()
  GeoJson!: string;

  @Prop()
  update!: any;

  private geoGroup: L.FeatureGroup;

  private layers: L.Layer[] = [];

  private padding: PointExpression = [25, 25];

  private map: L.Map;

  private tilesOpts = {
    url: TILES_URL,
    attribution: MAP_ATTRIBUTION
  };

  private onMapReady() {
    const mapComponent = this.$refs['geometry-map'] as LMap;
    this.map = mapComponent.mapObject;
    this.geoGroup = L.featureGroup();
    const geo = JSON.parse(this.GeoJson);
    const layer = L.geoJSON(geo, { style: { color: '#ffa500', weight: 2, opacity: 1 } }).addTo(this.map);
    this.layers.push(layer);
    this.geoGroup.addLayer(layer);
    this.map.fitBounds(this.geoGroup.getBounds());
  }

  @Watch('update', {
    deep: true,
    immediate: true
  })
  private refreshMap() {
    setTimeout(() => { this.map.invalidateSize(); }, 500);
  }
}
</script>
<style lang="scss" scoped>
@import './styles/domains-geometry-map.scss';
</style>
